import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const CancelIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M0 10C0 4.47716 4.47705 0 10 0C15.5229 0 20 4.47716 20 10C20 15.5228 15.5229 20 10 20C4.47705 20 0 15.5228 0 10ZM2 10C2 5.58173 5.58179 2 10 2C14.4182 2 18 5.58173 18 10C18 14.4183 14.4182 18 10 18C5.58179 18 2 14.4183 2 10ZM5.04102 15L7.99756 15L9.87061 11.3872L11.7607 15L14.8711 15L11.7334 9.84912L14.5908 5.20068L11.7334 5.20068L10.0552 8.43408L8.41455 5.20068L5.37939 5.20068L8.20605 9.84912L5.04102 15Z"
        clipRule="evenodd"
        fill="currentColor"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
